import React,{useContext} from 'react';
import {SoundContext} from "./SoundContext";
import usePlaySound from '../hooks/usePlaySound';
import Button from '@mui/material/Button';
import {useNavigate} from 'react-router-dom';

export default function SoundButtonPlayer({children,href, onClick, ...props}){
    const {isSoundOn} = useContext(SoundContext);
    const playTypeSound = usePlaySound('/assets/audio/typing.mp3');
    const nav = useNavigate();

    const handleClick =async (e)=>{
        if(isSoundOn){
            playTypeSound();
            await new Promise(resolve => setTimeout(resolve, 100));//suggested to add more natural feel
        }
        if(href){//do we have a link to work with?
            e.preventDefault();
            setTimeout(()=>{
                nav(href);
            },100);//check if number needs to be adjusted
        }
        if(onClick){
            onClick(e);
        }
    }

    return(
        <Button {...props} 
            onClick={handleClick}
            href={href ? undefined : props.href}//pass href if not using this custom nav
        >
            {children}
        </Button>
    );

}